import { useReveal } from "@/hooks/useReveal";

export default function About() {
  const ref = useReveal<HTMLDivElement>();

  return (
    <section id="about" className="bg-cream py-20 md:py-28">
      <div className="max-w-[1200px] mx-auto px-4 md:px-6">
        <div ref={ref} className="reveal grid grid-cols-1 lg:grid-cols-2 gap-10 items-center">
          <div className="w-full h-72 md:h-[420px] rounded-lg overflow-hidden">
            <img
              src="https://storage.helloreaddy.io/project_files/1d5eebb5-cdd6-4798-a44f-e501204aaa58/852df2b4-fea8-4760-aa22-f665df516b3b_compressed_who-is-behind-this.webp"
              alt="Smallholder farmer standing in a green mountain farm field in Colombia's coffee region"
              loading="lazy"
              className="w-full h-full object-cover object-top"
            />
          </div>

          <div>
            <h2 className="text-ink font-serif text-3xl md:text-4xl font-semibold">
              Who is behind this
            </h2>
            <p className="mt-5 text-ink/80 text-[17px] leading-relaxed">
              Mesa Baja is based in Armenia, in Quindío, in the heart of
              Colombia&apos;s coffee region. We buy directly from smallholder
              farmer cooperatives who grow under certified organic practice,
              and we process, pack and export from our own certified plant. The
              company is led by Sara Grisales Olaya. Our production volume is
              deliberately modest, which is why we can run small batches and
              develop a private label range that a larger plant would not take
              on.
            </p>
          </div>
        </div>
      </div>
    </section>
  );
}